/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:8835d0e7-4faf-40d3-a25c-ad27f6784a72",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_7phqV32la",
    "aws_user_pools_web_client_id": "52uuklstichh8658p182740m18",
    "oauth": {},
    "aws_user_files_s3_bucket": "annazonc1efc57982804c54b3b7b949e190e52b145119-prod",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://abp2jwm2cfb7rjbix7ubgp2wam.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-gkdm3xx7djacpovtk5srmepv6i"
};


export default awsmobile;
